import Backbone from "backbone";

export default Backbone.View.extend({

  initialize: function () {
    this.initializeClock(new Date(this.$el.data("endtime")));
  },

  initializeClock: function (endDate) {
    var day = this.$el.data("day"),
      hour = this.$el.data("hour"),
      minute = this.$el.data("minute"),
      second = this.$el.data("second");
    var timeinterval = setInterval(() => {
      var t = this.getTimeRemaining(endDate);
      this.$el.text((t.days && t.days + day + ' ' || '') +
        t.hours + hour + ' ' +
        t.minutes + minute + ' ' +
        t.seconds + second);
      if (t.total <= 0) {
        clearInterval(timeinterval);
      }
    }, 1000);
  },

  getTimeRemaining: function (endDate) {
    var startDate = new Date();
    var t = endDate - startDate;
    var seconds = Math.floor(t / 1000 % 60);
    var minutes = Math.floor(t / 1000 / 60 % 60);
    var hours = Math.floor(t / (1000 * 60 * 60) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));

    return {
      'total': t,
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }

});
